import { render, staticRenderFns } from "./ComponentProductExchange.vue?vue&type=template&id=346e0c9a&scoped=true&"
import script from "./ComponentProductExchange.vue?vue&type=script&lang=ts&"
export * from "./ComponentProductExchange.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentProductExchange.vue?vue&type=style&index=0&id=346e0c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e0c9a",
  null
  
)

export default component.exports